import { jsx as t } from "react/jsx-runtime";
import { createElement as p } from "react";
import { withManagedProps as i } from "@made-people/managed-props";
import { z as l } from "zod";
import { withZod as s } from "@made-people/react-prop-guard";
import { sliderPropsSchema as n, Slider as c } from "@made-people/blueprint-slider";
import { blogTeaserVariantsSchema as d, blogTeaserSchema as h, BlogTeaser as b } from "@made-people/blueprint-blog-teaser";
const f = l.object({
  sliderSettings: n.omit({ children: !0 }).optional(),
  itemVariants: d,
  items: h.array().optional()
}), j = i(
  "BlogTeaserSlider",
  s(f, ({ sliderSettings: e, itemVariants: r, items: o }) => /* @__PURE__ */ t(
    c,
    {
      templateProps: {
        template: "dresden",
        ...e == null ? void 0 : e.templateProps
      },
      sliderSettings: {
        mode: "snap",
        breakpoints: {
          mobile: {
            perView: 1.5,
            spacing: 16
          },
          laptop: {
            perView: 3.2,
            spacing: 24
          }
        },
        ...e
      },
      children: (o ?? []).map((a, m) => /* @__PURE__ */ p(
        b,
        {
          ...a,
          variants: r,
          key: `${m}-blog-teaser-card`
        }
      ))
    }
  ))
);
export {
  j as BlogTeaserSlider,
  f as blogTeaserSliderSchema
};
//# sourceMappingURL=index.es.js.map
